export function iframeHeight() {
    const iframes = Array.from(document.querySelectorAll('[data-iframe-form]'));
    if (!iframes?.length)
        return;
    function adjustIframeHeight(iframe) {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        if (iframeDoc) {
            iframe.style.height = iframeDoc.body.scrollHeight + 'px';
        }
    }
    iframes.forEach(iframe => {
        iframe.addEventListener('load', () => adjustIframeHeight(iframe));
        window.addEventListener('resize', () => adjustIframeHeight(iframe));
    });
}
